<template>
<div class="">
    <div v-for="(block, key) in blocks" :key="block.id || key" class="p-3 rounded mb-3 bg-light border">
        <div class="mb-2 row align-items-center">
            <label for="eventName2" class="col-3 col-form-label small">
            追加項目
            </label>
            <div class="col-7">
            <input type="text" :name="'items[' + key + '][title]'" v-model="block.title" class="form-control" :id="'eventName_' + key" placeholder="クローク" maxlength="255">
            </div>
            <div class="col-2">
            <img v-if="key != 0" @click="deleteBlock(key)" src="/images/icon_delete.png" width="32" alt="削除">
            </div>
        </div>
        <div class="mb-2 row align-items-center">
            <label :for="'note_' + key" class="col-12 col-md-3 col-form-label small text-center text-md-start">
            ご案内テキスト
            </label>
            <div class="col-12 col-md-9">
            <textarea :name="'items[' + key + '][body]'" v-model="block.body" rows="4" class="form-control" :id="'note_' + key" placeholder="例）お荷物は1Fロビーの受付にてお預かりいたします" maxlength="20000">
            </textarea>

            </div>
        </div>
    </div>

    <div class="text-center mb-3">
      <button class="btn btn-sm btn-outline-primary px-4" type="button" @click="addBlock" v-if="Object.keys(blocks).length < max">
        ＋ 項目を追加
      </button>
    </div>
</div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        old: {
            type: Array,
            default: () => []
        },
        items: {
            type: Array,
            default: []
        },
        max: {
            type: Number,
            default: 10
        },
    },
    mounted() {
        console.log('=== EventAddItem mounted() 開始 ===');
        console.log('this.items:', this.items);
        console.log('this.items.length:', this.items ? this.items.length : 'undefined');
        console.log('typeof this.items:', typeof this.items);
        console.log('Array.isArray(this.items):', Array.isArray(this.items));
        console.log('this.old:', this.old);
        console.log('this.old.length:', this.old ? this.old.length : 'undefined');
        
        // itemsを優先して処理し、baseDataの構造に合わせて正規化
        if(this.items && this.items.length > 0) {
            console.log('🔵 itemsからblocksを作成');
            this.blocks = this.items.map(item => ({
                id: item.id || null,
                title: item.title || '',
                body: item.body || '',
                offset: item.offset || 0
            }));
            console.log('作成されたblocks:', this.blocks);
        } else if(this.old && this.old.length > 0) {
            console.log('🟡 oldからblocksを作成');
            this.blocks = this.old.map(item => ({
                id: item.id || null,
                title: item.title || '',
                body: item.body || '',
                offset: item.offset || 0
            }));
            console.log('作成されたblocks:', this.blocks);
        } else {
            console.log('🟠 新しいブロックを追加');
            // どちらも空の場合は新しいブロックを追加
            this.addBlock();
            console.log('addBlock後のblocks:', this.blocks);
        }
        
        console.log('=== EventAddItem mounted() 終了 ===');
        console.log('最終的なthis.blocks:', this.blocks);
    },
    watch: {
        items: {
            handler(newItems) {
                console.log('=== items prop changed ===');
                console.log('新しいitems:', newItems);
                console.log('newItems.length:', newItems ? newItems.length : 'undefined');
                
                if (newItems && newItems.length > 0) {
                    console.log('🔵 watchでitemsからblocksを再作成');
                    this.blocks = newItems.map(item => ({
                        id: item.id || null,
                        title: item.title || '',
                        body: item.body || '',
                        offset: item.offset || 0
                    }));
                    console.log('watch後のblocks:', this.blocks);
                }
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            baseData : {
                id : null,
                title : '',
                body  : '',
                offset: 0,
            },
            radioBaseData: {
                id : null,
                title : '',
            },
            blocks: [],
        }
    },
    methods: {
        addBlock() {
            if (this.blocks.length <= 10) {
                var copy = Object.assign({}, this.baseData)
                this.blocks.push(copy)
            }
        },
        // 選択肢削除
        deleteBlock(index) {
            this.blocks.splice(index, 1)
        },
    }
}
</script>
